<template>
  <div class="task-detail-navs d-flex align-center justify-space-between" data-testid="task-detail-navs">
    <button
      type="button"
      class="task-detail-navs__back d-flex align-center gap-1"
      aria-label="Back to tasks"
      data-testid="task-detail-navs__back-btn"
      @click="$emit('back')"
    >
      <img
        src="/img/icons/fbc-icons/BackArrow.svg"
        alt=""
        class="task-detail-navs__back-icon-image"
        data-testid="task-detail-navs__back-icon"
      >
      <span class="task-detail-navs__back-text" data-testid="task-detail-navs__back-text">Back to tasks</span>
    </button>

    <div class="task-detail-navs__right d-flex align-center" data-testid="task-detail-navs__right">
      <v-tooltip bottom content-class="tooltip-bottom" open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <button
            type="button"
            class="task-detail-navs__icon-btn task-detail-navs__refresh-btn"
            v-bind="attrs"
            v-on="on"
            :disabled="refreshLoading"
            aria-label="Refresh task"
            data-testid="task-detail-navs__refresh-btn"
            @click="$emit('refresh')"
          >
            <v-progress-circular
              v-if="refreshLoading"
              indeterminate
              size="16"
              width="2"
              color="var(--grey-900)"
              data-testid="task-detail-navs__refresh-loading"
            />
            <img
              v-else
              src="/img/icons/fbc-icons/RefreshIcon.svg"
              alt=""
              class="task-detail-navs__refresh-icon"
              data-testid="task-detail-navs__refresh-icon"
            >
          </button>
        </template>
        <span>Refresh</span>
      </v-tooltip>

      <div class="task-detail-navs__segmented" data-testid="task-detail-navs__center">
        <v-tooltip left content-class="tooltip-left" open-delay="500" :disabled="!hasPrev">
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="task-detail-navs__segment-btn"
              v-bind="attrs"
              v-on="on"
              :disabled="!hasPrev"
              aria-label="Previous task"
              data-testid="task-detail-navs__prev-btn"
              @click="$emit('prev-task')"
            >
              <v-icon small>mdi-chevron-left</v-icon>
            </button>
          </template>
          <span>Previous task</span>
        </v-tooltip>

        <TaskQuickPeek
          :tasks="peekTasks"
          :current-task-id="currentTaskId"
          :page="peekPage"
          :total-pages="peekTotalPages"
          :total-task-count="peekTotalTaskCount"
          data-testid="task-detail-navs__quick-peek"
          @select-task="$emit('select-task', $event)"
        />

        <v-tooltip left open-delay="500" content-class="tooltip-left" :disabled="!hasNext">
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="task-detail-navs__segment-btn task-detail-navs__segment-btn--last"
              v-bind="attrs"
              v-on="on"
              :disabled="!hasNext"
              aria-label="Next task"
              data-testid="task-detail-navs__next-btn"
              @click="$emit('next-task')"
            >
              <v-icon small>mdi-chevron-right</v-icon>
            </button>
          </template>
          <span>Next task</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import TaskQuickPeek from './TaskQuickPeek.vue';
import './TaskDetailNavs.scss';

export default {
  name: 'TaskDetailNavs',

  components: {
    TaskQuickPeek,
  },

  props: {
    currentTaskId: {
      type: String,
      default: '',
    },
    hasPrev: {
      type: Boolean,
      default: false,
    },
    hasNext: {
      type: Boolean,
      default: false,
    },
    peekTasks: {
      type: Array,
      default: () => [],
    },
    peekPage: {
      type: Number,
      default: 1,
    },
    peekTotalPages: {
      type: Number,
      default: 1,
    },
    peekTotalTaskCount: {
      type: Number,
      default: 0,
    },
    refreshLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
